import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { trainingsAPI } from '../services/api';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Progress } from './ui/progress';
import { GraduationCap, ArrowRight, Sparkles } from 'lucide-react';

const TrainingWidget = () => {
  const navigate = useNavigate();
  const [ov, setOv] = useState(null);

  useEffect(() => {
    trainingsAPI.overview().then(r => setOv(r.data)).catch(() => {});
  }, []);

  if (!ov || !ov.total) return null;
  // Hide if user is fully trained
  if (ov.percent >= 100) return null;
  const next = ov.continue_learning || ov.recommended;
  if (!next) return null;

  return (
    <Card className="border-l-4 border-l-gold-500 bg-gradient-to-r from-navy-50 to-white" data-testid="training-widget">
      <CardContent className="py-4">
        <div className="flex items-center justify-between gap-3 flex-wrap">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-gold-100 flex items-center justify-center">
              {ov.continue_learning ? <Sparkles className="w-5 h-5 text-gold-600" /> : <GraduationCap className="w-5 h-5 text-gold-600" />}
            </div>
            <div>
              <p className="text-xs text-muted-foreground">🎓 {ov.continue_learning ? 'Kontynuuj szkolenie' : 'Polecane szkolenie'}</p>
              <p className="font-semibold text-navy-800">{next.title}</p>
              <p className="text-xs text-muted-foreground mt-0.5">Postęp ogólny: <strong>{ov.percent}%</strong> ({ov.completed}/{ov.total} modułów)</p>
            </div>
          </div>
          <Button
            size="sm"
            onClick={() => {
              window.dispatchEvent(new CustomEvent('openTraining', { detail: next }));
            }}
            className="bg-gold-500 hover:bg-gold-600 text-navy-800"
            data-testid="training-widget-continue"
          >
            Kontynuuj<ArrowRight className="w-4 h-4 ml-1" />
          </Button>
        </div>
        <Progress value={ov.percent} className="h-1.5 mt-3" />
      </CardContent>
    </Card>
  );
};

export default TrainingWidget;
